import { useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ContainerTemplate } from './ContainerTemplate';
import { RevokeApprovalModal } from '../RevokeApprovalModal';
import { UsersWithInstallAccessDrawer } from '../UsersWithInstallAccessDrawer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function RevokeApproval() {
  const [showRevokeApprovalModal, setShowRevokeApprovalModal] = useState(false);
  const [showUsersWithInstallAccessDrawer, setShowUsersWithInstallAccessDrawer] = useState(false);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showUsersWithInstallAccessDrawer && /*#__PURE__*/_jsx(UsersWithInstallAccessDrawer, {
      onClose: () => setShowUsersWithInstallAccessDrawer(false)
    }), showRevokeApprovalModal && /*#__PURE__*/_jsx(RevokeApprovalModal, {
      onClose: () => setShowRevokeApprovalModal(false),
      showUsersWithInstallAccessDrawer: () => {
        setShowUsersWithInstallAccessDrawer(true);
        // We want the modal to be closed when the users with install access drawer is shown, just so there aren't overwhelming dialogs
        setShowRevokeApprovalModal(false);
      }
    }), /*#__PURE__*/_jsx(ContainerTemplate, {
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app-governance-lib.revokeApproval.description"
      }),
      children: /*#__PURE__*/_jsx(Button, {
        "data-selenium": "revoke-approval-open-modal",
        use: "danger",
        onClick: () => setShowRevokeApprovalModal(true),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app-governance-lib.revokeApproval.button"
        })
      })
    })]
  });
}